export const DESTROY_SESSION = "DESTROY_SESSION"
